import * as Yup from "yup";
import { transformSnakeToCamel } from "utils/transform";

/**
 * Transaction Admin Schema
 * Represents administrative transactions in the system
 */
export const PaymentSchema = Yup.object().transform(transformSnakeToCamel).shape({
  id: Yup.string().required(),
  earningsId: Yup.string().required(),
  imageUrl: Yup.string().required(),
  uploadedBy: Yup.string().required(),
  createdAt: Yup.date().nullable(),
  updatedAt: Yup.date().nullable(),
});
